export const getAvatarInitials = string => {
  const initials = string
    .split(' ')
    .splice(0, 2)
    .map((i, idx, self) => {
      return self.length > 1 ? i.charAt(0) : i.substr(0, 2);
    })
    .join('');
  return initials;
};
